import { FC } from 'react';
import Skeleton from '../presentational/skeleton';
import { Spinner } from '../presentational/spinner';

const SkeletonGuildRaidAchievementsPage: FC<any> = () => {
  return (
    <div style={{ marginTop: 24 }}>
      <Skeleton height={218} />
      <Skeleton variant="item" height={564} style={{ position: 'relative' }}>
        <Spinner />
      </Skeleton>
    </div>
  );
};

export default SkeletonGuildRaidAchievementsPage;

